import Backbone from 'backbone';


export default Backbone.Model.extend({
  urlRoot: APPOINTMENT_API_URL,
  url: function () {
    return this.urlRoot + this.id + '/';
  },
  parse: function (response) {
    var split = response.url.split('/');
    response.id = split[split.length - 2];
    return response;
  }
});



// WEBPACK FOOTER //
// ./static/js/models/appointment.js